import { inicioGuard, moduloGuard } from '@intelishs-group/session-core';
import { Routes } from '@angular/router';
import { Prospectos } from '@pages/prospectos/prospectos.page';
import { Calendario } from '@pages/calendario/calendario.page';

export const routes: Routes = [
  {
    // Al entrar: la PRIMERA pantalla del acceso (el primer módulo por su orden en identidad),
    // no un destino fijo.
    path: '',
    pathMatch: 'full',
    canActivate: [inicioGuard()],
    children: [],
  },
  // Antes iba sin guard porque era el destino fijo de `rutaSinPermiso`.
  {
    path: 'prospecto/prospectos',
    component: Prospectos,
    canActivate: [moduloGuard('prospectos')],
  },
  {
    path: 'prospecto/calendario',
    component: Calendario,
    canActivate: [moduloGuard('calendario')],
  },
  {
    // Lo que no existe vuelve a la primera pantalla del acceso. `children: []` y no
    // `redirectTo`: una redirección no corre guards.
    path: '**',
    canActivate: [inicioGuard()],
    children: [],
  },
];
